import React, { useContext, useEffect, useMemo } from "react";
import { Link, NavLink } from "react-router-dom";

// blocks
import SideMenuUserNew from "../SideMenu/SideMenuUserNew";
import SideMenuNav from "../SideMenu/SideMenuNav";
import logo from "../../../img/solimat-logo.svg";
import IconUser from "../../../img/NewDesign/img/user.svg";
import IconHamburger from "../../../img/01.svg";
import IconBell from "../../../img/NewDesign/img/bell.svg";
import IconBellActive from "../../../img/NewDesign/img/bell.svg";
import PuntoRojo from "../../../img/NewDesign/img/punto-rojo.svg";
// contexts
import { HeaderContext } from "../../../contexts/HeaderContext";
import { PromptContextProvider } from "../../../contexts/SideMenuUserContext";
import { SignalRContext } from "../../../contexts/SignalRContext";
import "./HeaderNew.scss";
import useDecode from "../../../hooks/useDecode";
import useCountNoticesAndNotifications from "../../../services/notices/useCountNoticesAndNotifications";
import { useGeneralManagementState } from "../../pages/GeneralManagement/generalManagementState";
import Surveys2 from "components/pages/Surveys/Surveys2";
import MenuCircular from "./MenuCircular";
import useObtenerEncuestas from "services/surveys/useObtenerEncuestas";
import { EstadoRespuesta } from "@solimat/solimat-web-endpoint/lib/survey-ingestion/dto";

interface IHeaderNewProps {
  dataSource: any;
  homePath: string;
  children?: any;
  isCompany?: boolean;
  isImpersonation?: boolean;
}

const HeaderNew: React.FC<IHeaderNewProps> = (Props: IHeaderNewProps) => {
  const { headerState, setHeaderState } = useContext(HeaderContext);
  const { notification, allUserNotifications, isUpdated } = useContext(SignalRContext);
  const { countNotices, countNotifications, getCounts } = useCountNoticesAndNotifications();
  const { encuestas, obtenerEncuestas } = useObtenerEncuestas();
  const { state, dispatch } = useGeneralManagementState();
  const { countNotice } = state;
  const aplication = localStorage.getItem("impersonationApp");
  const tfp = useDecode("token")?.tfp || "";
  const tokenResponse = useDecode("token");
  const idUser = tokenResponse?.extension_id;

  useEffect(() => {
    getCounts(idUser);
  }, [idUser, countNotice, notification, allUserNotifications, isUpdated]);

  useEffect(() => {
    obtenerEncuestas();
  }, []);

  useEffect(() => {
    dispatch({
      type: "SET_SURVEYS",
      payload: encuestas && encuestas,
    });
  }, [encuestas]);

  const activeSurveyCount = useMemo(() => {
    const src = Array.isArray(state.surveys) ? state.surveys : [];
    return src.reduce(
      (acc, s) =>
        acc +
        ((s.estadoRespuesta === EstadoRespuesta.Vacia ||
          s.estadoRespuesta === EstadoRespuesta.Rellena) &&
        !s.caducada
          ? 1
          : 0),
      0
    );
  }, [state.surveys]);

  const handleToggleMenu = () => {
    setHeaderState({ sideMenuVisible: true });
  };

  const handleToggleNav = () => {
    setHeaderState({ navMenuVisible: true });
  };

  const closeSurvey = () => {
    dispatch({
      type: "SHOW_SURVEY",
      payload: { show: false, id: "" },
    });
  };

  return (
    <>
      <header className={`header-new-block ${Props.isCompany ? "company" : ""}`}>
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="header-new-content">
                <div className="logo-new-block">
                  <div className="logo-new-container">
                    <Link to={Props.homePath} replace>
                      <img src={logo} className="logo-new" alt="solimat" />
                    </Link>
                  </div>
                </div>
                <div className="links-new-wrapper">
                  <nav className="nav-new-container d-none d-xl-flex">
                    {Props.isCompany && (
                      <div className="nav_filter">
                        <input type="text" />
                      </div>
                    )}
                    {Props.dataSource.map((item: any, i: any) => {
                      if (item.path === "/notificaciones") {
                        return (
                          <NavLink
                            to={item.path}
                            className="nav-new_link"
                            key={i}
                          >
                            <span className="nav-new_link-icon">
                              <img src={IconBell} alt="" />
                            </span>
                            {item.text}
                            {countNotifications >= 1 && (
                              <span className="nav-new_link-number">
                                ({countNotifications})
                              </span>
                            )}
                            {countNotifications >= 1 && (
                              <span className="nav-new_link-dot" />
                            )}
                          </NavLink>
                        );
                      }
                      return (
                        <NavLink
                          to={item.path}
                          className="nav-new_link"
                          key={i}
                        >
                          {item.text}
                        </NavLink>
                      );
                    })}
                  </nav>
                  <button
                    className="toggle-new_btn d-inline-block d-xl-none"
                    onClick={handleToggleNav}
                  >
                    <img src={IconHamburger} alt="" />
                  </button>
                  {!Props.isImpersonation && (
                    <button className="toggle-new_btn" onClick={handleToggleMenu}>
                      <img src={IconUser} alt="Usuario" />
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <MenuCircular
        key={`menu-${activeSurveyCount}-${countNotices}`}
        countSurvey={activeSurveyCount}
        countNotices={countNotices}
      />
      <PromptContextProvider>
        <SideMenuUserNew />
      </PromptContextProvider>
      <SideMenuNav />
      <Surveys2 handleCloseSurvey={closeSurvey} />

      {aplication ? (
        <p className="p-aplication-ext">
          PORTAL PACIENTES DESDE {aplication} {tfp}
        </p>
      ) : (
        ""
      )}
    </>
  );
};

export default HeaderNew;
